import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { CountryReportResponseV4Schema } from "../response/CountryReportResponseV4";
import { CountryReportFilterV4Type } from "../schema/CountryReportFilterSchemaV4";

const API_VERSION = 'v4';

interface CountryReportV4Props {
    filter?: CountryReportFilterV4Type;
    orderBy?: string;
    sort?: 'asc' | 'desc';
    type: string | null;
}

const useCountryReportV4 = (params: CountryReportV4Props) => {
    return useQuery({
        queryKey: [
            'report',
            'group-country-report', // Query key unik
            API_VERSION,
            params.type,
            JSON.stringify(params.filter),
            params.orderBy,
            params.sort,
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.post(`/${API_VERSION}/channel-manager/group-report-country`, {
                    filter: params.filter,
                    orderBy: params.orderBy,
                    sort: params.sort,
                });

                const validationResult = CountryReportResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Country report V4 data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Country report V4`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date && !!params.filter.base_on && params.type === "country_report",
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useCountryReportV4;